define('modules/profiles/subviews/views/edit.contact.sub.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/lists/modals/views/edit.contact.view',
    "text!modules/profiles/subviews/templates/edit.contact.sub.template.html"
], function(
    Prospector,
    $, _,Backbone,
    EditContactView,
    Template
){
    var EditContactSubView = EditContactView.extend({
        className: 'editContactSub',
        template: _.template(Template),
        mainBtnLoaderClass: 'reload_white_green_25',
        initialize: function(options) {
            this.parent = options.parent;
            EditContactView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = this.parent.model;
        },
        onRender:function(){
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
            this.procResponse();
        },
        procMainBtnResponse:function(){
            Prospector.trigger("clearToast");
            Prospector.trigger("closeTopDrawer");
            Prospector.trigger('profileUpdate');
            Prospector.trigger('refreshLists');
            Prospector.trigger('refreshEditContact');
            var that = this;
            that.parent.model.set({
                lists: that.identityModel.get('lists'),
                contactType: that.identityModel.get('contactType')
            });
            var msg = "Save Successful";
            Prospector.trigger("createToast", msg, {timeout: 3000});
        }
    });
    return EditContactSubView;
});
